import { create } from "zustand";

export const useGameStore = create((set) => ({
  games: [],
  searchQuery: "",
  activeCategory: "all",
  iframeUrl: null,
  isGameLoading: false,
  isSports: false,

  setGames: (games) => set({ games }),
  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setActiveCategory: (activeCategory) => set({ activeCategory }),
  launchGame: (url, isSports = false) => set({ iframeUrl: url, isGameLoading: true, isSports }),
  closeGame: () => set({ iframeUrl: null, isGameLoading: false, isSports: false }),
  setGameLoading: (isGameLoading) => set({ isGameLoading }),
}));
